import { onTrackEvent } from './onTrackEvent';
import loggerService from '../../../utils/loggerService';

/**
 * @param {number} count
 */
export const onCartCountUpdate = (count) => {
  document.querySelectorAll('mini-cart-button').forEach((el) => {
    el.count = count.toString();
  });
};

const onePageStoreEvent = {
  onCartCountUpdate,
  onTrackEvent,
  loggerService,
};

export default onePageStoreEvent;
